var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4062 14.655L11.3942 10.643C12.3583 9.48559 12.8391 8.00102 12.7365 6.49815C12.6339 4.99528 11.9559 3.58982 10.8434 2.57413C9.73098 1.55845 8.26979 1.01075 6.76381 1.04497C5.25783 1.07919 3.82302 1.69269 2.75785 2.75785C1.69269 3.82302 1.07919 5.25783 1.04497 6.76381C1.01075 8.26979 1.55845 9.73098 2.57413 10.8434C3.58982 11.9559 4.99528 12.6339 6.49815 12.7365C8.00102 12.8391 9.48559 12.3583 10.643 11.3942L14.655 15.4062L15.4062 14.655ZM2.12495 6.9062C2.12495 5.96056 2.40537 5.03616 2.93074 4.24988C3.45611 3.46361 4.20284 2.85079 5.0765 2.48891C5.95016 2.12702 6.91151 2.03234 7.83898 2.21683C8.76645 2.40131 9.61839 2.85668 10.2871 3.52535C10.9557 4.19402 11.4111 5.04596 11.5956 5.97343C11.7801 6.9009 11.6854 7.86225 11.3235 8.73591C10.9616 9.60957 10.3488 10.3563 9.56252 10.8817C8.77625 11.407 7.85185 11.6875 6.9062 11.6875C5.63857 11.686 4.42326 11.1819 3.5269 10.2855C2.63055 9.38915 2.12636 8.17384 2.12495 6.9062Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.083fd0043c968e22243c5af9b6e3dc5d.svg";
export { ForwardRef as ReactComponent };